import type { MeResponse } from '@ucp/web/lib';
import { moduleForPath } from './modulesConfig';
import { navItemsForUser, type NavItem } from './navConfig';

/**
 * Communications tier-2 task items (the bar under the module rail).
 *
 * `/commercial/*` entries live in `navConfig` so a caller can still reach them
 * when the Commercial module itself is hidden (contracts on, commercial data
 * off — the host of last resort). Once `commercialDataEnabled` mounts that
 * module, those destinations belong on the Commercial rail and its section
 * tabs, not beside Home / Compose / Surveys.
 */
export function commsTaskNavItems(
  user: Pick<MeResponse, 'roles' | 'featureFlags'>,
): NavItem[] {
  const items = navItemsForUser(user, user.featureFlags);
  if (user.featureFlags?.commercialDataEnabled === true) {
    return items.filter((item) => moduleForPath(item.path) !== 'commercial');
  }
  return items;
}
